import * as Sentry from '@sentry/nextjs';

type ENV = 'development' | 'production' | 'staging' | 'demo' | 'preview';

class Logger {
  private env: ENV = process.env.NODE_ENV as ENV;

  log(message: string, ...data: Record<string, unknown>[]) {
    console.log(message, ...data);
    if (this.env === 'development') return;

    switch (this.env) {
      case 'demo':
      case 'staging':
      case 'preview':
      case 'production':
        Sentry.logger.info(message, { ...data, env: this.env });
        break;
      default:
        Sentry.logger.info(message, { ...data, env: this.env });
        break;
    }
  }
  error(message: string, ...data: Record<string, unknown>[]) {
    console.error(message, ...data);
    if (this.env === 'development') return;

    switch (this.env) {
      case 'staging':
      case 'demo':
      case 'preview':
        Sentry.captureException(new Error(message), {
          extra: { ...data },
        });
        break;
      case 'production':
        Sentry.captureException(new Error(message), {
          extra: { ...data },
        });
        break;
      default:
        Sentry.captureException(new Error(message), {
          extra: { ...data },
        });
        break;
    }
  }
  info(message: string, ...data: Record<string, unknown>[]) {
    console.info(message, ...data);
    if (this.env === 'development') return;

    switch (this.env) {
      case 'staging':
      case 'demo':
      case 'preview':
        Sentry.logger.info(message, { ...data, env: this.env });
        break;
      case 'production':
        Sentry.logger.info(message, { ...data, env: this.env });
        break;
      default:
        Sentry.logger.info(message, { ...data, env: this.env });
        break;
    }
  }
  warn(message: string, ...data: Record<string, unknown>[]) {
    console.warn(message, ...data);
    if (this.env === 'development') return;

    switch (this.env) {
      case 'staging':
      case 'demo':
      case 'preview':
        Sentry.logger.warn(message, { ...data, env: this.env });
        break;
      case 'production':
        Sentry.logger.warn(message, { ...data, env: this.env });
        break;
      default:
        Sentry.logger.warn(message, { ...data, env: this.env });
        break;
    }
  }
}

export const logger = new Logger();
